import React, { useEffect, useState } from "react";

import FollowUp from "./FollowUp";
import Schedule from "./Schedule";

function HashComponent(props) {
  const [loadHash, setLoadHash] = useState(false);

  useEffect(
    () => {
      if (props.location.hash === "#follow-up") {
        setLoadHash(true);
      } else {
        setLoadHash(false);
      }
    },
    [props.location]
  );

  return <div>{loadHash ? <FollowUp /> : <Schedule />}</div>;
}

export default HashComponent;
